import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ERROR } from 'types';
import { GlobalInvitesFilters, GlobalInvitesSlice } from 'types/invite';
import { fetchInvitesThunk } from './thunk';

export const defaultGlobalInvitesFilters: GlobalInvitesFilters = {
    page: 1,
    mode: '',
    country: '',
    applied: '',
    collaborated: '',
    whatsapp_notified: '',
};

const initialState: GlobalInvitesSlice = {
    error: null,
    loading: false,
    filtered_lists: {},
    applied_filter_id: null,
    filters: defaultGlobalInvitesFilters,
};

const invitesSlice = createSlice({
    name: 'invites',
    initialState,
    reducers: {
        updateGlobalInvitesFilters: (state, { payload }: PayloadAction<GlobalInvitesFilters>) => {
            state.filters = {
                ...defaultGlobalInvitesFilters,
                ...payload,
                page: payload.page ?? 1,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInvitesThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInvitesThunk.fulfilled, (state, { payload }) => {
                const { count, items, filterId, filters } = payload;
                const existingList = state.filtered_lists?.[filterId]?.list ?? [];
                const list = filters.page === 1 ? items : [...existingList, ...items];

                state.filtered_lists = {
                    ...state.filtered_lists,
                    [filterId]: {
                        list,
                        page: filters.page,
                        expired: false,
                        last_fetched_at: Date.now(),
                        has_more: count > list.length,
                        count,
                    },
                };
                state.applied_filter_id = filterId;
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchInvitesThunk.rejected, (state, { payload }) => {
                state.loading = false;
                if (payload !== ERROR.CACHED) {
                    state.error = payload || 'Failed to fetch invites';
                }
            });
    },
});

export const { updateGlobalInvitesFilters } = invitesSlice.actions;
export default invitesSlice.reducer;
